import { render } from "./Logout.vue?vue&type=template&id=6d863046"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
script.render = render

export default script